<template>
  <!-- eslint-disable vue/no-v-html -->
  <page-wrapper>
    <div class="wrapper">
      <div class="decor decor__1" />
      <nav class="loco">
        <div class="loco_return">
          <a href="javascript:void(0);" @click.prevent="backToCatalogClickHandler">Назад в каталог</a>
        </div>
        <ol class="breadcrumbs loco_breadcrumbs" itemscope="" itemtype="https://schema.org/BreadcrumbList">
          <li
            id="breadcrumbs__item_0"
            class="breadcrumbs__item"
            itemprop="itemListElement"
            itemscope=""
            itemtype="https://schema.org/ListItem"
          >
            <a target="_self" href="/" itemprop="item">
              <span itemprop="name">Салон Love Forever</span>
            </a>
            <meta itemprop="position" content="1">
          </li>
          <li
            id="breadcrumbs__item_1"
            class="breadcrumbs__item"
            itemprop="itemListElement"
            itemscope=""
            itemtype="https://schema.org/ListItem"
            itemref="breadcrumbs__item_2"
          >
            <a target="_self" :href="`/${category.slug}/`" itemprop="item">
              <span itemprop="name">{{ category.name }}</span>
            </a>
            <meta itemprop="position" content="2">
          </li>
          <li
            id="breadcrumbs__item_2"
            class="breadcrumbs__item"
            itemprop="itemListElement"
            itemscope=""
            itemtype="https://schema.org/ListItem"
            v-bind="thirdBreadCrumb"
          >
            <a target="_self" :href="`/${category.slug}/${item.brand.slug}/`" itemprop="item">
              <span itemprop="name">{{ item.brand.name_eng }}</span>
            </a>
            <meta itemprop="position" content="3">
          </li>
          <li
            v-if="style"
            id="breadcrumbs__item_3"
            class="breadcrumbs__item"
            itemprop="itemListElement"
            itemscope=""
            itemtype="https://schema.org/ListItem"
          >
            <a target="_self" :href="`/${category.slug}/?style=${style.slug}`" itemprop="item">
              <span itemprop="name">{{ style.name }}</span>
            </a>
            <meta content="4" itemprop="position">
          </li>
          <li>
            {{ item.name }}
            <meta v-if="style" itemprop="position" content="5">
            <meta v-else itemprop="position" content="4">
          </li>
        </ol>
      </nav>

      <section class="product" itemscope itemtype="http://schema.org/Product">
        <!--        <meta itemprop="sku" :content="item.id">
        <meta itemprop="mpn" :content="`${item.brand.id}-${item.id}`">-->
        <span style="display:none;" itemprop="brand" itemscope itemtype="https://schema.org/Brand">
          <meta itemprop="name" :content="item.brand.name_eng">
        </span>
        <!--        <meta itemprop="description" :content="fullFilledSeoDescription ? fullFilledSeoDescription : ''">-->
        <div class="product_wrapper">
          <div class="product_content thin">
            <em class="product_meta">
              <a
                :href="`/${category.slug}/${item.brand.slug}/`"
                target="_self"
              >
                <span>{{ item.brand.name_eng }}</span>
              </a>
            </em>
            <span itemprop="name" class="product_title" v-html="productTitle" />
            <noindex>
              <button
                v-if="item.active"
                class="item-fav-link mobile_fav_button"
                :class="favoriteButtonClasses(item.id)"
                title="Добавить в «Любимое», чтобы посмотреть позже"
                @click="toggleFavorite(item.id)"
              >
                <span class="fav-but-text-mobile">Хочу примерить</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="27px" height="25px" viewBox="0 0 24 24">
                  <path
                    d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z"
                  />
                </svg>
              </button>
            </noindex>
          </div>
          <div class="product_wrapper_inner">
            <meta itemprop="image" :content="firstSlidePhotoUrl">

            <div v-if="isTabletOrMobile" class="product_carousel">
              <div v-if="!showCarousel" style="position: relative; align-content: center; text-align: center; min-height: 150vw">
                <img :src="firstSlidePhotoUrl" />
              </div>
              <LazyHydrate>
                <carousel v-show="showCarousel" :per-page="1" :pagination-padding="0" :pagination-size="6" @mounted="showCarousel = true">
                    <slide v-if="hasVideo" style="position: relative; align-content: center; text-align: center; min-height: 150vw;">
                      <img src="/img/preloader.svg" />
                      <VideoBackground
                        :src="video1080?.url ?? video720?.url ?? video460?.url"
                        :sources="srcVideos"
                        style="background-color: #f8f8f8; position: absolute; top: 0; left: 0;"
                      />
                    </slide>
                    <slide v-for="photo in slides" :key="photo.id" @click.native="onMobilePreviewClick(photo)">
                      <img :src="`${imageURL}/uploads/item/1000-1500/${photo.hash}${photo.ext}`">
                    </slide>
                  </carousel>
                </LazyHydrate>
              </div>

            <template v-else>
                <div v-if="!currentSlide && hasVideo" class="video-container">
                  <img src="/img/preloader.svg" />
                  <VideoBackground
                      :src="video1080?.url ?? video720?.url ?? video460?.url"
                      :sources="srcVideos"
                      style="position: absolute; top:0; left:0;"
                    />
                </div>

                <ZoomableImage
                    v-else-if="currentSlide"
                    :src="`${imageURL}/uploads/item/1000-1500/${currentSlide.hash}${currentSlide.ext}`"
                    :zoom-src="`${imageURL}/uploads/item/${currentSlide.hash}${currentSlide.ext}`"
                    :image-ratio="1000 / 1500"
                    :drift-options="{
                      hoverDelay: 600
                    }"
                  />

                <ul id="product-gallery" class="product_thumbs">
                  <li
                    v-if="hasVideo"
                  >
                    <a
                      v-lazy-container="{
                        selector: 'img',
                        loading: '/img/preloader.svg',
                        throttleWait: 0,
                      }"
                      :class="{
                        'is-active': videoSelected
                      }"
                      class="gallery_thumb_link"
                      href="#"
                      @click="videoThumbnailClickHandler"
                    ><img
                      :data-src="firstSlidePhotoUrlSmall"
                      lazy="loading"
                      src="/img/preloader.svg"
                      :alt="fullFilledSeoTitle"
                    >
                      <div style="position: absolute; z-index: 999; background-image: url('/img/play.png'); width:120px; height: 180px; background-repeat: no-repeat; background-position: center;" />

                    </a>
                  </li>

                  <li v-for="photo in slides" :key="photo.id">
                    <a
                      v-lazy-container="{
                        selector: 'img',
                        loading: '/img/preloader.svg',
                        throttleWait: 0,
                      }"
                      :class="{
                        'is-active': currentSlide && currentSlide.id === photo.id
                      }"
                      class="gallery_thumb_link"
                      href="#"
                      @click="thumbPhotoClickHandler(photo, $event)"
                    ><img
                      :data-src="`${imageURL}/uploads/item/120-180/${photo.hash}${photo.ext}`"
                      lazy="loading"
                      src="/img/preloader.svg"
                      :alt="fullFilledSeoTitle"
                    ></a>
                  </li>
                </ul>
              </template>

          </div>
          <div class="product_content">
            <div class="wide">
              <em class="product_meta">
                <a
                  :href="`/${category.slug}/${item.brand.slug}/`"
                  target="_self"
                >
                  <span>{{ item.brand.name_eng }}</span>
                </a>
              </em>
              <h1 class="product_title" v-html="productTitle" />
              <div v-if="item.active" class="fav_but_wrap">
                <noindex>
                  <button
                    class="item-fav-link"
                    :class="favoriteButtonClasses(item.id)"
                    title="Добавить в «Любимое», чтобы посмотреть позже"
                    @click="toggleFavorite(item.id)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="27px" height="25px" viewBox="0 0 24 24">
                      <path
                        d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z"
                      />
                    </svg>
                    <span class="fav-but-text">Хочу примерить</span>
                  </button>
                </noindex>
              </div>
            </div>

            <ul class="product_properties">
              <li class="product_property product_property__about">
                <h2>Описание</h2>
                <template v-if="item.description">
                  <div itemprop="description" v-html="item.description" />
                  <br>
                  <hr>
                  <br>
                </template>
                <div class="keywords" v-text="itemStyles" />
              </li>
              <li class="product_property product_property__color">
                <h2>Цвета</h2>
                <ul class="product_colors">
                  <li v-for="color in item.colors" :key="color.id" class="product_color">
                    <span :style="{ backgroundColor: color.code }" />
                    <em>{{ color.name }}</em>
                  </li>
                </ul>
              </li>
              <li class="product_property">
                <div class="product_price product_price__sale">
                  <template v-if="item.active">
                    <h2>Цена</h2>
                    <div class="product_price_splash" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                      <strong>{{ item.price | currency }}<i class="fa fa-rub" aria-hidden="true" /></strong>
                      <div v-if="item.price_old > 0" class="product_price_discount">
                        {{ item.price_old | currency }}<i class="fa fa-rub" aria-hidden="true" />
                      </div>
                      <meta :content="item.price" itemprop="price">
                      <meta itemprop="priceCurrency" content="RUB">
                      <meta itemprop="sku" :content="item.id">
                      <link itemprop="availability" href="http://schema.org/InStock">
                      <meta itemprop="priceValidUntil " :content="priceValidUntilDate">
                      <!--                      <link itemprop="url" href="linkToProduct">-->
                    </div>
                    <br>
                    <span style="font-size: 11px; font-weight: bold"><sup>*</sup>Актуальную цену уточняйте по телефону&nbsp;8&nbsp;(495)&nbsp;645&nbsp;19&nbsp;08</span>
                    <br>
                    <br>
                  </template>

                  <a
                    v-if="item.active"
                    class="buy-button add-to-favorite"
                    data-mfp-decor="mfp-product"
                    href="#popup-request"
                    @mousedown="toggleFavorite(item.id)"
                  ><strong>ДОБАВИТЬ В ЛЮБИМЫЕ</strong></a>

                  <div v-if="item.in_stock && item.active" class="product_splash">
                    <span class="decor-marble" />
                    <a
                      class="fitting-widget-link"
                      data-mfp-decor="mfp-product"
                      href="#"
                      @click.prevent="openFittingWidgetHandler"
                    >Записаться на примерку
                    </a>
                  </div>
                  <div v-else class="product_not_available product_splash">
                    <span class="decor-marble" />
                    <a href="javascript:void(0);" @click.prevent>Отсутствует в продаже</a>
                  </div>
                  <a
                    v-if="item.active"
                    class="buy-button js-popup js-request"
                    data-mfp-decor="mfp-product"
                    href="#popup-buy-request"
                    data-popup="buy"
                    @mousedown="setDressToBuy"
                  ><strong>КУПИТЬ</strong></a>

                  <div class="product_price_note">
                    Примерить и купить платье можно в нашем салоне по адресу ул. Б. ЯКИМАНКА 50 (м. ОКТЯБРЬСКАЯ)
                    ежедневно с 10:00 до 22:00 по предварительной записи на примерку! <br><br>Также
                    мы доставляем в регионы
                    <span class="upper">бесплатно!</span>
                    <br><br>
                    Закажите обратный звонок
                    <!--                    <a
                      class="pseudo js-popup js-request"
                      data-mfp-decor="mfp-product"
                      href="#popup-request"
                    >обратный звонок
                    </a>-->
                    и мы вам перезвоним.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <Recommends :recomend-items="randomItems" />
      </section>
    </div>
    <client-only v-if="zoomModalSrc">
      <pinch-modal :src="zoomModalSrc" @close="zoomModalSrc = null" />
    </client-only>
  </page-wrapper>
</template>

<script>
import Recommends from '@/components/Recommends'
import {
  CLIENT_URL,
  IMAGE_URL,
  LAST_CATALOG_URL,
  RETURN_LINK_CLICKED,
  SEO_ENTITIES,
  SEO_TYPES
} from '@/assets/js/constants'
import Bus from '@/assets/js/bus'
import { app } from '@/assets/js/common'
import analyticsMixin from '@/assets/mixins/analytics.mixin'
import { cookieStore } from '@/assets/js/storejs'
import { getCleanItemForItemPage, replaceWithFilters } from '@/helpers/utils'
import PageWrapper from './PageWrapper'
import PinchModal from './PinchModal'
import VideoBackground from '@/components/video/VideoBackground'
import LazyHydrate from 'vue-lazy-hydration'
import MapWrapper from '@/components/controls/MapWrapper.vue'

const findSeoByType = (targetArray, type, categoryId = null) => {
  return targetArray ? targetArray.find((element) => {
    return element.type === type && ((categoryId && element.category && element.category.id === categoryId) || !categoryId)
  }) : null
}

export default {
  name: 'ItemWrapper',
  components: {
    MapWrapper,
    LazyHydrate,
    PinchModal,
    PageWrapper,
    Recommends,
    VideoBackground,
  },
  mixins: [analyticsMixin],
  async asyncData ({ params, $axios, store, error, query }) {
    const categorySlug = params.category || null
    const brandSlug = params.brand || null
    const itemSlug = params.item || null
    let styleSlugs = query.style || null

    if (!(categorySlug || itemSlug)) {
      return error({
        statusCode: 404,
        message: 'Тут только лепестки роз'
      })
    }

    const categoryObject = store.state.categories?.find(category => category.slug === categorySlug)

    if (categorySlug && !categoryObject) {
      return error({
        statusCode: 404,
        message: 'Тут только лепестки роз'
      })
    }

    let styleObject

    if (styleSlugs && !Array.isArray(styleSlugs)) {
      styleSlugs = [styleSlugs]
    }

    if (styleSlugs) {
      styleObject = store.state.styles.find(style => style.slug === styleSlugs[0])
    }

    if (styleSlugs?.length && !styleObject) {
      styleObject = store.state.styles.find(style => style.old_ids?.includes(parseInt(styleSlugs[0])))
    }

    if (styleSlugs?.length && !styleObject) {
      styleObject = store.state.styles.find(style => style.id === parseInt(styleSlugs[0]))
    }

    if (styleSlugs?.length && !styleObject) {
      return error({
        statusCode: 404,
        message: 'Тут только лепестки роз'
      })
    }

    const itemObject = await store.dispatch('loadItem', {
      itemSlug,
      brandSlug,
      categorySlug
    })

    const item = getCleanItemForItemPage(itemObject)

    if (itemSlug && !item) {
      return error({
        statusCode: 404,
        message: 'Тут только лепестки роз'
      })
    }

    const limit = 6

    await store.dispatch('loadRandomItems', {
      limit,
      exclude: item.id
    })

    let seoGlobalKey = SEO_ENTITIES.ITEMS
    let seoTypeToUse = SEO_TYPES.ITEM

    if (styleObject) {
      seoGlobalKey = SEO_ENTITIES.ITEMSANDSTYLE
      seoTypeToUse = SEO_TYPES.ITEM_STYLE

      styleObject = await $axios.$get(`/styles/${styleObject.id}`)
      styleObject.categories = []
    }

    const seoGlobal = store.state.seoEntities.find(item => item.type === seoGlobalKey)
    const globalSeoTemplate = findSeoByType(seoGlobal?.seo, seoTypeToUse)
    const localCategorySeoTemplate = findSeoByType(categoryObject.seo, seoTypeToUse)
    const localStyleSeoTemplate = findSeoByType(styleObject?.seo, seoTypeToUse)
    const localStyleCategorySeoTemplate = findSeoByType(styleObject?.seo, seoTypeToUse, categoryObject.id)

    if (store.getters.isConsoleActive) {
      // eslint-disable-next-line no-console
      console.info('ItemPage asyncData ->', {
        seoGlobalKey,
        seoTypeToUse,
        styleObject,
        seoGlobal,
        globalSeoTemplate,
        localCategorySeoTemplate,
        localStyleSeoTemplate,
        localStyleCategorySeoTemplate
      }, {
        categorySlug,
        brandSlug,
        styleSlug: styleObject?.slug || null
      })
    }

    return {
      category: categoryObject,
      style: styleObject || null,
      item,
      globalSeoTemplate,
      localCategorySeoTemplate,
      localStyleSeoTemplate,
      localStyleCategorySeoTemplate
    }
  },
  data: () => {
    return {
      currentSlide: null,
      imageURL: IMAGE_URL,
      zoomModalSrc: null,
      videoSelected: false,
      showTheServerImage: true,
      showCarousel: false,
    }
  },
  computed: {
    video460 () {
      if (this.item.videos) {
        return this.item.videos?.find(video => video.resolution === '460')
      }

      return undefined
    },
    video720 () {
      if (this.item.videos) {
        return this.item.videos?.find(video => video.resolution === '720')
      }
      return undefined
    },
    video1080 () {
      if (this.item.videos) {
        return this.item.videos?.find(video => video.resolution === '1080')
      }
      return undefined
    },
    hasVideo () {
      return !!this.video1080?.url || !!this.video720?.url || !!this.video460?.url
    },
    firstSlidePhotoUrl () {
      if (!this.slides.length) {
        return null
      }
      return `${this.imageURL}/uploads/item/1000-1500/${this.slides[0].hash}${this.slides[0].ext}`
    },
    firstSlidePhotoUrlSmall () {
      if (!this.slides.length) {
        return null
      }
      return `${this.imageURL}/uploads/item/58-87/${this.slides[0].hash}${this.slides[0].ext}`
    },
    srcVideos () {
      return [
        this.video460 ? { src: this.video460?.url, res: 460, autoplay: true } : undefined,
        this.video720 ? { src: this.video720?.url, res: 720, autoplay: true } : undefined,
        this.video1080 ? { src: this.video1080?.url, res: 1080, autoplay: true } : undefined
      ].filter(Boolean)
    },
    productTitle () {
      const nameHeader = this.itemPrefix + ' от бренда ' + this.item.brand.name_eng + '<br>' + '"' + this.item.name + '"'
      if (this.style) {
        if (this.style.item_header) {
          return nameHeader + `<br /><hr><span class="style_H1"> ${this.style.item_header}</span>`
        } else if (this.style.header) {
          return nameHeader + `<br /><hr><span class="style_H1"> ${this.style.header}</span>`
        }
        return nameHeader + `<br /><hr><span class="style_H1"> в стиле - ${this.style.name}</span>`
      }

      return nameHeader
    },
    itemSalons () {
      return this.item.salons.map(item => item.name)
    },
    isTabletOrMobile () {
      return app.isIpadDesktop || app.tablet || app.mobile
    },
    itemPrefix () {
      const saleWord = 'Распродажа: <br>'
      const catsWithPrefix = this.item.categories?.filter(el => el.item_prefix)
      let result = ''

      if (this.category.slug === 'sale') {
        result = saleWord
      }
      if (this.category.item_prefix) {
        result += this.category.item_prefix
      } else {
        result += catsWithPrefix.length ? catsWithPrefix[0].item_prefix : ''
      }
      return result
    },
    seoItemPrefix () {
      return this.itemPrefix.replace(/<br>/g, '')
    },
    thirdBreadCrumb () {
      const attrs = {}
      if (this.style) {
        attrs.itemref = 'breadcrumbs__item_3'
      }
      return attrs
    },
    mainImage () {
      return this.slides[0]
    },
    randomItems () {
      return this.$store.state.randomItems
    },
    favoriteItems () {
      return this.$store.state.favorite.items
    },
    favoriteButtonClasses () {
      return (id) => {
        return {
          'added heartBeat animated': this.favoriteItems.includes(id)
        }
      }
    },
    itemStyles () {
      return this.item.styles.filter(style => !!style.active).map(style => style.name).join(', ')
    },
    categories () {
      return this.$store.state.categories
    },
    slides () {
      return [this.item.photo_main, ...this.item.photo_gallery]
    },
    canonicalUrl () {
      let result = ''
      function f (element, index, array) {
        if (element.base) {
          return element
        }
      }
      if (this.item.categories?.length === 1) {
        // eslint-disable-next-line no-unused-vars
        return `${CLIENT_URL}/${this.category.slug}/${this.item.brand.slug}/${this.item.slug}/`
      } else if (this.item.categories?.length > 1) {
        const categoryBase = this.item.categories.find(f)
        if (categoryBase !== undefined) {
          result = categoryBase
        } else {
          // eslint-disable-next-line no-unused-vars
          result = this.item.categories[0]
        }
      }
      return `${CLIENT_URL}/${result.slug}/${this.item.brand.slug}/${this.item.slug}/`
    },
    fullFilledSeoTitle () {
      return this.fillSeoTemplate(this.seoTitle)
    },
    fullFilledSeoDescription () {
      return this.fillSeoTemplate(this.seoDescription)
    },
    seoTitle () {
      return this.getSeoField('title')
    },
    seoDescription () {
      return this.getSeoField('description')
    },
    priceValidUntilDate () {
      const today = new Date()
      const tomorrow = new Date()
      tomorrow.setDate(today.getDate() + 10)

      return `${tomorrow.getFullYear()}-${(tomorrow.getMonth() + 1) >= 10 ? tomorrow.getMonth() + 1 : '0' + (tomorrow.getMonth() + 1)}-${tomorrow.getDate() >= 10 ? tomorrow.getDate() : '0' + tomorrow.getDate()}`
    },

    linkToProduct () {
      return this.$route.path
    }

  },
  mounted () {
    if (app.prepared) {
      setTimeout(() => {
        app.popups()
      }, 0)
    }

    if (this.$fb) {
      this.$fb.track('ViewContent', {
        value: this.item.price,
        currency: 'RUB',
        content_name: `${this.itemPrefix} ${this.item.name}`,
        content_category: this.category.slug,
        content_type: 'product',
        content_ids: [this.item.id]
      })
    }

    this.showTheServerImage = false
  },
  created () {
    this.currentSlide = this.hasVideo ? undefined : this.slides[0]
    this.videoSelected = this.hasVideo
  },
  methods: {
    videoThumbnailClickHandler ($event) {
      $event.preventDefault()
      this.currentSlide = undefined
      this.videoSelected = true
    },
    getSeoField (field) {
      if (this.localStyleCategorySeoTemplate && this.localStyleCategorySeoTemplate[field]) {
        return this.localStyleCategorySeoTemplate[field]
      } else if (this.localStyleSeoTemplate && this.localStyleSeoTemplate[field]) {
        return this.localStyleSeoTemplate[field]
      } else if (this.localCategorySeoTemplate && this.localCategorySeoTemplate[field]) {
        return this.localCategorySeoTemplate[field]
      } else if (this.globalSeoTemplate && this.globalSeoTemplate[field]) {
        return this.globalSeoTemplate[field]
      }
      return null
    },
    onMobilePreviewClick (photo) {
      this.zoomModalSrc = `${this.imageURL}/uploads/item/${photo.hash}${photo.ext}`
    },
    setDressToBuy () {
      this.$store.commit('setBuyDress', this.item)
      this.$store.commit('setBuyDressPrefix', this.itemPrefix)
      this.$store.commit('setRequestCallAnalyticType', 'callback_from_buy')
    },
    backToCatalogClickHandler () {
      try {
        cookieStore.set(RETURN_LINK_CLICKED, 'true')
      } catch (error) {
        this.$sentry.captureException(error)
        // возможно приватный режим
        // eslint-disable-next-line no-console
        console.error('Error of local storage', error)
      }

      const url = cookieStore.get(LAST_CATALOG_URL)
      if (url) {
        cookieStore.remove(LAST_CATALOG_URL)
        window.location.href = url
      } else {
        history.back()
      }
    },
    fillSeoTemplate (str) {
      if (!str) {
        return ''
      }

      if (this.category) {
        if (this.seoItemPrefix) {
          str = replaceWithFilters(str, 'category.item_prefix', this.seoItemPrefix)
        }
        if (this.category.name) {
          str = replaceWithFilters(str, 'category.name', this.category.name)
        }
        if (this.category.noun) {
          // eslint-disable-next-line camelcase
          const { kto_chto, kogo_chto, kogo_chego, kto_chto_m, kogo_chto_m, kogo_chego_m } = this.category.noun
          // eslint-disable-next-line camelcase
          if (kto_chto) {
            str = replaceWithFilters(str, 'category.kto_chto', kto_chto)
          }
          // eslint-disable-next-line camelcase
          if (kogo_chto) {
            str = replaceWithFilters(str, 'category.kogo_chto', kogo_chto)
          }
          // eslint-disable-next-line camelcase
          if (kogo_chego) {
            str = replaceWithFilters(str, 'category.kogo_chego', kogo_chego)
          }
          // eslint-disable-next-line camelcase
          if (kto_chto_m) {
            str = replaceWithFilters(str, 'category.kto_chto_m', kto_chto_m)
          }
          // eslint-disable-next-line camelcase
          if (kogo_chto_m) {
            str = replaceWithFilters(str, 'category.kogo_chto_m', kogo_chto_m)
          }
          // eslint-disable-next-line camelcase
          if (kogo_chego_m) {
            str = replaceWithFilters(str, 'category.kogo_chego_m', kogo_chego_m)
          }
        }
        if (this.category.declension) {
          const { kakoy, kakaya, kakoe, kakie, kakih } = this.category.declension

          if (kakoy) {
            str = replaceWithFilters(str, 'category.kakoy', kakoy)
          }
          if (kakaya) {
            str = replaceWithFilters(str, 'category.kakaya', kakaya)
          }
          if (kakoe) {
            str = replaceWithFilters(str, 'category.kakoe', kakoe)
          }
          if (kakie) {
            str = replaceWithFilters(str, 'category.kakie', kakie)
          }
          if (kakih) {
            str = replaceWithFilters(str, 'category.kakih', kakih)
          }
        }
      }

      str = replaceWithFilters(str, 'item.name', this.item.name)
      str = replaceWithFilters(str, 'item.price', this.item.price)
      str = replaceWithFilters(str, 'item.brand.name_eng', this.item.brand.name_eng)
      str = replaceWithFilters(str, 'item.brand.name', this.item.brand.name)

      const style = this.style || (this.item.styles.length && this.item.styles[0]) || null

      if (style) {
        if (style.name) {
          str = replaceWithFilters(str, 'style.name', style.name)
        }
        if (style.item_header) {
          str = replaceWithFilters(str, 'style.item_header', style.item_header)
        }
        if (style.declension) {
          const { kakoy, kakaya, kakoe, kakie, kakih } = style.declension

          if (kakoy) {
            str = replaceWithFilters(str, 'style.kakoy', kakoy)
          }
          if (kakaya) {
            str = replaceWithFilters(str, 'style.kakaya', kakaya)
          }
          if (kakoe) {
            str = replaceWithFilters(str, 'style.kakoe', kakoe)
          }
          if (kakie) {
            str = replaceWithFilters(str, 'style.kakie', kakie)
          }
          if (kakih) {
            str = replaceWithFilters(str, 'style.kakih', kakih)
          }
        }
      }

      return str
    },
    openFittingWidgetHandler () {
      Bus.$emit('open-fitting-widget')
    },
    thumbPhotoClickHandler (photo, $event) {
      $event.preventDefault()
      this.currentSlide = photo
      this.videoSelected = false
    }
  },
  head () {
    return {
      bodyAttrs: {
        class: 'page-loveforever'
      },
      title: this.fullFilledSeoTitle,
      meta: [{
        name: 'description',
        content: this.fullFilledSeoDescription
      }],
      link: [{
        rel: 'canonical',
        href: this.canonicalUrl
      }]
    }
  }
}
</script>

<style lang="scss">
.video-placeholder-image {
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
}

.product_image:not([lazy='loaded']) {
  background-image: url('/img/preloader.svg');
  background-size: 100px 20px;
  background-position: center;
}

.product_not_available a {
  border-bottom: 0;
}

.style_H1 {
  font-size: 0.5em;
  color: #929292;
}

.buy-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  border-radius: 20px;
  border: 1px solid #d994b6;
  color: #d994b6;
  text-decoration: none;
}

.mobile_fav_button {
  position: absolute;
  display: flex;
  align-items: center;
  right: 22px;
  top: 24px;
  height: 25px;
}

.fav_but_wrap .item-fav-link {
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-fav-link svg path {
  stroke: #fa809d;
  fill: #fff;
  stroke-width: 2;
  stroke-opacity: 0.6;
}

.item-fav-link:hover svg {
  transform: scale(1.1);
}

.item-fav-link.added svg path {
  fill: #fa809d;
  stroke: #fff;
}

.fav-but-text {
  color: #fa809d;
  padding-left: 10px;
  font-size: medium;
  text-transform: uppercase;
}

.fav-but-text-mobile {
  color: #fa809d;
  padding-right: 10px;
  font-size: small;
  text-align: center;
  text-transform: uppercase;
}

.fav-text {
  color: #fa809d;
  margin-top: 10px;
  font-size: small;
}

.product_carousel {
  width: 500px;
  height: 750px;
  text-align: center;
  overflow: hidden;
  background: none !important;

  img {
    width: 500px;
    height: 750px;
    max-width: none;
  }

  .VueCarousel-dot-container {
    padding: 1px 2px;
    border-radius: 4px;
    background: hsla(0, 0%, 0%, 0.45) !important;
  }

  button.VueCarousel-dot {
    width: 10px;
    height: 10px;
    display: inline-block;
    border: 2px solid #fff;
    border-radius: 50%;
    margin: 4px;
    background: none !important;

    &:focus {
      outline: none;
    }

    &--active {
      background: #fff !important;
    }
  }

  .VueCarousel-pagination {
    position: absolute;
    bottom: 15px;
  }
}

@media (max-width: 1005px) {
  .product_carousel {
    width: 100%;
    height: unset;
    text-align: center;
    overflow: hidden;
    background: none !important;

    img {
      height: auto;
      width: unset;
      max-width: 100%;
    }
  }

  .buy-button {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    max-width: 360px;
  }
}

.product_thumbs li {
  width: 120px;
  height: 180px;

  .gallery_thumb_link {
    display: flex;
    justify-content: center;
  }

  img:not([lazy='loaded']) {
    width: 55px;
    min-width: unset;
  }
}

.upper {
  text-transform: uppercase;
}

.add-to-favorite {
  margin-bottom: 40px;
}

.pinch-zoom-wrapper {
  height: 100%;
}

.product_wrapper_inner .video-container {
  position: relative;
  width: 500px;
  height: 750px;
  align-content: center;
  text-align: center;
  background-color: #f8f8f8;
}

.product_wrapper_inner .server-placeholder-image {
  width: 500px;
  height: 750px;
  max-width: none;
}
</style>
